import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

class AdmissionsTabHeader extends Component {
    render() {
        const { location, history } = this.props;

        const tabs = [
            { key: "/admissions-dashboard", label: "Dashboard", icon: "fal fa-tachometer-alt" },
            { key: "/admission-forms", label: "Manage Forms", icon: "fal fa-folder-open" },
            // { key: "/message-center", label: "Messages", icon: "fal fa-comments" },
            { key: "/lead-management", label: "Lead Management", icon: "fal fa-tasks" },
        ];

        return (
            <div style={{ background: "#f8fafc", borderBottom: "1.5px solid #e2e8f0", padding: "12px 24px 0 24px", marginBottom: "20px" }}>
                <ul className="nav nav-tabs" style={{ borderBottom: "none", gap: 8 }}>
                    {tabs.map((tab) => {
                        const isActive = location.pathname.startsWith(tab.key);

                        return (
                            <li className="nav-item" key={tab.key}>
                                <a
                                    className={`nav-link ${isActive ? "active" : ""}`}
                                    href="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        history.push(tab.key);
                                    }}
                                    style={{
                                        cursor: "pointer",
                                        fontWeight: 700,
                                        fontSize: 14,
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 8,
                                        padding: "12px 20px",
                                        color: isActive ? "#6366f1" : "#4b5563",
                                        background: isActive ? "#fff" : "transparent",
                                        borderColor: isActive ? "#e2e8f0 #e2e8f0 #fff" : "transparent",
                                        borderWidth: "1.5px",
                                        borderBottomWidth: isActive ? "2px" : "1.5px",
                                        borderRadius: "10px 10px 0 0",
                                        transition: "all 0.15s ease",
                                        marginBottom: "-1.5px"
                                    }}
                                >
                                    <i className={tab.icon} />
                                    {tab.label}
                                </a>
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    }
}

export default withRouter(AdmissionsTabHeader);
